export default "__VITE_ASSET__41SZ8qWk__"